// extracted by mini-css-extract-plugin
module.exports = {"body":"WhatsNewAlert_body__jqoD8","imageWrapper":"WhatsNewAlert_imageWrapper__lvLzq","whatsNewWrapper":"WhatsNewAlert_whatsNewWrapper__v7XXe"};